// extracted by css-extract-rspack-plugin
export default {"messagePair":"PromptMessagePair-module__messagePair__UhwO0","pairHeader":"PromptMessagePair-module__pairHeader__rLsgL"};